import { FC } from 'react'
import { cn } from '@wellesley/ui'
import monogramLogoLight from './monogram-light.svg'
import monogramLogoDark from './monogram-dark.svg'

type CopyrightProps = {
  isDarkBg?: boolean
}

export const Copyright: FC<CopyrightProps> = ({ isDarkBg }) => {
  const copyrightTextClass = isDarkBg ? 'text-white/50' : 'text-gray-900/50'
  const wellesleyTextClass = isDarkBg ? 'text-white/90' : 'text-gray-900/90'
  const monogramLogo = isDarkBg ? monogramLogoLight : monogramLogoDark
  return (
    <div
      data-testid="branding-copyright"
      className="flex items-center gap-xxxs text-sm font-normal"
    >
      <img src={monogramLogo} alt="monogram logo" />
      <span className={cn(copyrightTextClass)}>
        Copyright © {new Date().getFullYear()},
      </span>
      <span className={cn(wellesleyTextClass)}>Wellesley</span>
    </div>
  )
}
